import React from 'react'
import { Modal as ReactNativeModal } from 'react-native'

import { Backdrop } from './styled'
import { CompactModalContent } from './subcomponents/CompactModalContent'
import { FilterOptionsModalContent } from './subcomponents/FilterOptionsModalContent'
import { FullScreenModalContent } from './subcomponents/FullScreenModalContent'
import { NoContent } from './subcomponents/NoContent'
import { ModalProps } from './types'

export const Modal = ({
  children,
  variant = 'fullscreen',
  isVisible,
  onClose,
  ...props
}: ModalProps) => {
  if (!isVisible) return <></>

  let Component = variant === 'fullscreen' ? FullScreenModalContent : CompactModalContent
  if (variant === 'fullscreenModal') {
    Component = FilterOptionsModalContent
  }
  if (variant === 'fullscreenNoContent') {
    Component = NoContent
  }

  return (
    <ReactNativeModal
      animationType='fade'
      onRequestClose={onClose}
      transparent
      visible={isVisible}
      presentationStyle='pageSheet'
    >
      <Backdrop onPressIn={onClose} pointerEvents='auto'>
        <Component onClose={onClose} {...props}>
          {children}
        </Component>
      </Backdrop>
    </ReactNativeModal>
  )
}
